import type { GenMessage } from '@bufbuild/protobuf/codegenv1'
import type { UseMutationOptions } from '@connectrpc/connect-query'
import { useMutation } from '@connectrpc/connect-query'

import type {
  CheckEmailRequest,
  CheckEmailResponse,
} from '@jotta/grpc-connect-openapi/signup'
import { checkEmail } from '@jotta/grpc-connect-openapi/signupQuery'

import { createConnectQuery } from '../createConnectQuery'

export const checkEmailQuery = createConnectQuery(checkEmail)

export function useCheckEmail(
  options?: UseMutationOptions<
    GenMessage<CheckEmailRequest>,
    GenMessage<CheckEmailResponse>
  >,
) {
  return useMutation(checkEmail, options)
}
